import { baseApi } from "./baseApi";

const DRIVER_ROUTE_ASSIGNMENT_BASE_URL = "/driver-route-assignments";

export const driverRouteAssignmentApi = baseApi.injectEndpoints({
  tagTypes: ["DriverRouteAssignment"],

  endpoints: (builder) => ({
    addDriverRouteAssignment: builder.mutation({
      query: (payload) => ({
        url: DRIVER_ROUTE_ASSIGNMENT_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "DriverRouteAssignment", id: _id },
        { type: "DriverRouteAssignment", id: "LIST" },
      ],
    }),

    listDriverRouteAssignment: builder.query({
      query: (params) => ({
        url: DRIVER_ROUTE_ASSIGNMENT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "DriverRouteAssignment",
                id: _id,
              })),
              { type: "DriverRouteAssignment", id: "LIST" },
            ]
          : [{ type: "DriverRouteAssignment", id: "LIST" }],
    }),
    listDriverVehicleRoutine: builder.query({
      query: (params) => ({
        url: `${DRIVER_ROUTE_ASSIGNMENT_BASE_URL}/vehicleRoutine`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "DriverRouteAssignment",
                id: _id,
              })),
              { type: "DriverRouteAssignment", id: "LIST" },
            ]
          : [{ type: "DriverRouteAssignment", id: "LIST" }],
    }),

    getDDLDriverRouteAssignment: builder.query({
      query: (params) => ({
        url: `${DRIVER_ROUTE_ASSIGNMENT_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "DriverRouteAssignment",
                id: _id,
              })),
              { type: "DriverRouteAssignment", id: "DDL" },
            ]
          : [{ type: "DriverRouteAssignment", id: "DDL" }],
    }),

    updateDriverRouteAssignment: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${DRIVER_ROUTE_ASSIGNMENT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "DriverRouteAssignment", id },
        { type: "DriverRouteAssignment", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useAddDriverRouteAssignmentMutation,
  useListDriverRouteAssignmentQuery,
  useLazyListDriverRouteAssignmentQuery,
  useLazyListlistDriverVehicleRoutineQuery,
  useLazyGetDDLDriverRouteAssignmentQuery,
  useUpdateDriverRouteAssignmentMutation,
} = driverRouteAssignmentApi;
